<template>
  <div>
    <Card>
      <Row style="margin-bottom:15px">
        <Col span="24">
          <Button type="primary" @click="addBtn()" :disabled="loading">{{
            $t("Add Performance_Template")
          }}</Button
          ><!--新增绩效类型-->
          <Button style="margin:0 20px" :disabled="loading" @click="saveData">{{
            $t("Save")
          }}</Button
          ><!--保存-->
          <span style="font-size:14px;color:#333333">{{
            $t("longText29")
          }}</span> </Col
        ><!--若同一用户组被重复分配绩效类型，系统使用默认绩效类型--> </Row
      ><!--备注说明：没有分配任何用户组的人，就使用默认绩效类型-->
      <Alert type="error" style="margin:20px 0">{{ $t("longText30") }}</Alert>
      <P style="margin-bottom:20px"
        >1.{{
          $t("Be_Default_Performance_Template")
        }}
        &nbsp;&nbsp;&nbsp;&nbsp;<!--绩效类型（是否默认-->
        <RadioGroup v-model="SelectTrue" @on-change="getDefault()">
          <Radio
            v-for="item in performanceList"
            :label="item.value"
            :key="item.value"
            :disabled="loading"
            >{{ lang == "zh" ? item.label : item.enLabel }}</Radio
          > </RadioGroup
        >）
      </P>
      <Table border :loading="loading" :columns="columns" :data="data">
        <template slot-scope="{ row, index }" slot="action1">
          <Button
            icon="md-create"
            type="warning"
            size="small"
            style="margin-right: 8px"
            @click="editData(row, index)"
            >{{ $t("Edit") }}</Button
          ><!--编辑-->
          <Button
            icon="md-trash"
            type="error"
            size="small"
            @click="deletedData(index)"
            >{{ $t("Delete") }}</Button
          ><!--删除-->
        </template>
      </Table>
      <div style="display: flex; justify-content: flex-start;margin-top:20px">
        <Button
          style="margin-right:20px"
          :disabled="loading"
          @click="addAssessmentType"
          >{{ $t("Add_Performance_Type") }}</Button
        ><!--新增考评类型-->
        <Button
          style="margin-right:20px"
          :disabled="loading || SelectTrue == '1'"
          @click="openSelectRole"
          >{{ $t("Select") }}</Button
        ><!--选择用户组-->
      </div>
    </Card>

    <Card
      style="margin-top: 30px"
      v-for="(item, Index) in showList"
      :key="item.index"
    >
      <P style="margin-bottom:20px"
        >{{ Index + 2 }}.{{
          $t("Be_Default_Performance_Template")
        }}
        &nbsp;&nbsp;&nbsp;&nbsp;<!--绩效类型（是否默认-->
        <RadioGroup
          v-model="showDefault[Index]"
          @on-change="changeDefault(Index)"
        >
          <Radio
            v-for="item in performanceList"
            :label="item.value"
            :key="item.value"
            :disabled="loading"
            >{{ lang == "zh" ? item.label : item.enLabel }}</Radio
          > </RadioGroup
        >）
      </P>
      <Table
        border
        :loading="loading"
        :columns="columns1"
        :data="item"
        :disabled="loading"
      >
        <template slot-scope="{ row, index }" slot="action">
          <Button
            icon="md-create"
            type="warning"
            size="small"
            style="margin-right: 8px"
            @click="editBtn(row, index, Index)"
            >{{ $t("Edit") }}</Button
          ><!--编辑-->
          <Button
            icon="md-trash"
            type="error"
            size="small"
            @click="deletedBtn(index, Index)"
            >{{ $t("Delete") }}</Button
          ><!--删除-->
        </template>
      </Table>
      <div
        style="display: flex; justify-content: space-between; margin-top:20px"
      >
        <div>
          <Button
            style="margin-right:20px"
            :disabled="loading"
            @click="addAssessmentTypes(Index)"
            >{{ $t("Add_Performance_Type") }}</Button
          ><!--新增考评类型-->
          <Button
            style="margin-right:20px"
            :disabled="loading || showDefault[Index] == '1'"
            @click="selectListId(Index)"
            >{{ $t("Select") }}</Button
          ><!--选择用户组-->
        </div>
        <div>
          <Button
            icon="md-trash"
            type="error"
            :disabled="loading"
            @click="deleted(Index)"
            >{{ $t("Delete") }}</Button
          ><!--删除-->
        </div>
      </div>
    </Card>

    <div>
      <!-- <Button style="float:right;margin-top:15px;margin-right:20px" :disabled="loading" @click="saveData">保存</Button> -->
    </div>
    <Modal v-model="listId" :title="$t('Select')" width="60%" hight="400px"
      ><!--选择用户组-->
      <Form
        :label-width="150"
        label-position="left"
        style="padding: 20px 20px 0 30px"
      >
        <FormItem :label="$t('Select') + '：'"
          ><!--选择用户组-->
          <Select v-model="selectId" :clearable="true" placeholder="" multiple>
            <Option
              :value="item.roleId"
              v-for="item in roleList"
              :key="item.roleId"
              >{{ item.roleName }}</Option
            >
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="selectConfirm">{{ $t("Confirm") }}</Button
        ><!--确定-->
      </div>
    </Modal>
    <Modal v-model="selectRole" :title="$t('Select')" width="60%"
      ><!--选择用户组-->
      <Form
        :label-width="150"
        label-position="left"
        style="padding: 10px 20px 0 20px"
      >
        <FormItem :label="$t('Select') + '：'"
          ><!--选择用户组-->
          <Select v-model="roleId" :clearable="true" placeholder="" multiple>
            <Option
              :value="item.roleId"
              v-for="item in roleList"
              :key="item.roleId"
              >{{ item.roleName }}</Option
            >
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="confirmSelect">{{ $t("Confirm") }}</Button
        ><!--确定-->
      </div>
    </Modal>

    <Modal
      v-model="assessmentType"
      :title="
        action == 1 ? $t('Add_Performance_Type') : $t('Edit_Performance_Type')
      "
      width="600px"
      ><!--新增考评类型--><!--编辑考评类型-->
      <div class="center" style="padding: 0 40px;">
        <Form :label-width="150" label-position="left">
          <FormItem :label="$t('Code')"
            ><!--类型编码-->
            <Input v-model="formItem.evaCode" />
          </FormItem>
          <FormItem :label="$t('Performance_Type')"
            ><!--考评类型-->
            <Select
              v-model="formItem.evaType"
              :clearable="true"
              placeholder=""
              filterable
            >
              <Option
                :value="item.code"
                v-for="item in assessmentTypeList"
                :key="item.code"
                >{{ lang == "zh" ? item.name1 : item.enName }}</Option
              >
            </Select>
          </FormItem>
          <CheckboxGroup v-model="checkedData">
            <Checkbox
              v-for="item in dataListName"
              :label="item.code"
              :key="item.code"
            >
              <span style="margin-left: 10px">{{
                lang == "zh" ? item.name : item.enName
              }}</span>
            </Checkbox>
          </CheckboxGroup>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="confirmSave">{{ $t("Confirm") }}</Button
        ><!--确定-->
      </div>
    </Modal>
    <!-- List 遍历里的 -->
    <Modal
      v-model="assessmentTypes"
      :title="
        action == 1 ? $t('Add_Performance_Type') : $t('Edit_Performance_Type')
      "
      width="600px"
      ><!--新增考评类型--><!--编辑考评类型-->
      <div class="center" style="padding: 0 40px;">
        <Form :label-width="150" label-position="left">
          <FormItem :label="$t('Code')"
            ><!--类型编码-->
            <Input v-model="formItem.evaCode" />
          </FormItem>
          <FormItem :label="$t('Performance_Type')"
            ><!--考评类型-->
            <Select
              v-model="formItem.evaType"
              :clearable="true"
              placeholder=""
              filterable
            >
              <Option
                :value="item.code"
                v-for="item in assessmentTypeList"
                :key="item.code"
                >{{ lang == "zh" ? item.name1 : item.enName }}</Option
              >
            </Select>
          </FormItem>
          <CheckboxGroup v-model="checkedData">
            <Checkbox
              v-for="item in dataListName"
              :label="item.code"
              :key="item.code"
            >
              <span style="margin-left: 10px">{{
                lang == "zh" ? item.name : item.enName
              }}</span>
            </Checkbox>
          </CheckboxGroup>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="confirmSaves">{{ $t("Confirm") }}</Button
        ><!--确定-->
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  data() {
    return {
      date: new DateUtil(),
      formItem: {},
      data: [],
      showList: [],
      performanceList: [
        {
          label: "是",
          value: "1",
          enLabel: "Yes"
        },
        {
          label: "否",
          value: "0",
          enLabel: "No"
        }
      ],
      loading: false,
      assessmentType: false,
      assessmentTypes: false,
      assessmentTypeList: [],
      kpiScore: null,
      bscScore: null,
      sllScore: null,
      qualitativeScore: null,
      index: null,
      row: {},
      fewTables: 0,
      action: 0, //新增1，编辑2
      theIndex: 0,
      beDefault: [{ beDefault: "" }],
      selectRole: false,
      actionIndex: 0,
      countNum: 0,
      roleList: [],
      roleId: [],
      str: "",
      listId: false,
      selectId: [],
      SelectTrue: "0",
      showDefault: [],
      evaTypeRepeat1: false,
      evaTypeRepeat2: false,
      evaTypeRepeat3: false,
      dataListName: [],
      checkedData: [],
      tableId: "",
      fondIndex: 0,
      scoreType: "", //判断是data还是showList
      lang: "",
      columns: [
        {
          title: this.$t("Code") /* 类型编码 */,
          key: "evaCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Performance_Type") /* 考评类型 */,
          key: "evaType",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            var name = "";
            this.assessmentTypeList
              ? this.assessmentTypeList.map(item => {
                  if (item.code == params.row.evaType) {
                    name = this.lang == "zh" ? item.name1 : item.enName;
                  }
                })
              : "";
            return h("span", name);
          }
        },
        {
          title: this.$t("Action") /* 操作 */,
          slot: "action1",
          align: "center",
          minWidth: 200
        }
      ],
      columns1: [
        {
          title: this.$t("Code") /* 类型编码 */,
          key: "evaCode",
          minWidth: 120,
          align: "center"
        },
        {
          title: this.$t("Performance_Type") /* 考评类型 */,
          key: "evaType",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            var name = "";
            this.assessmentTypeList
              ? this.assessmentTypeList.map(item => {
                  if (item.code == params.row.evaType) {
                    name = this.lang == "zh" ? item.name1 : item.enName;
                  }
                })
              : "";
            return h("span", name);
          }
        },
        {
          title: this.$t("Action") /* 操作 */,
          slot: "action",
          align: "center",
          minWidth: 200
        }
      ]
    };
  },
  watch: {
    "$i18n.locale"(newValue) {
      this.dataListName.forEach(el => {
        this.columns.forEach((res, index) => {
          if (el.code == res.key) {
            newValue == "zh" ? (res.title = el.name) : (res.title = el.enName);
          } else {
            this.columnsA.forEach(function(e) {
              if (e.key == res.key) {
                res.title = e.title;
              }
            });
          }
        });
        this.columns1.forEach((res, index) => {
          if (el.code == res.key) {
            newValue == "zh" ? (res.title = el.name) : (res.title = el.enName);
          } else {
            this.columnsA.forEach(function(e) {
              if (e.key == res.key) {
                res.title = e.title;
              }
            });
          }
        });
      });
      this.lang = newValue;
    }
  },

  computed: {
    columnsA() {
      return [
        {
          title: this.$t("Code"), //"类型编码"
          key: "evaCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Performance_Type"), //"考评类型"
          key: "evaType",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            var name = "";
            this.assessmentTypeList
              ? this.assessmentTypeList.map(item => {
                  if (item.code == params.row.evaType) {
                    name = this.lang == "zh" ? item.name1 : item.enName;
                  }
                })
              : "";
            return h("span", name);
          }
        },
        {
          title: this.$t("Action"), //"操作"
          slot: "action1",
          align: "center",
          minWidth: 200
        }
      ];
    }
  },
  mounted() {
    this.lang = this.$store.getters.selectLangeData;
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      axios.post("/AchievementType/selectAchievementType", {}).then(res => {
        this.loading = false;
        this.assessmentTypeList = res.label;
        let arr = res.extendsAchievementsType;
        arr.forEach((item2, index) => {
          item2.forEach(item => {
            if (item.achievementsDetailList.length > 0) {
              item.achievementsDetailList.forEach(item3 => {
                item[item3.achItemMasterId] = true;
              });
            }
          });
        });
        if (arr[0].length > 0 && arr[0][0].tableId == 1) {
          this.data = arr[0];
          this.SelectTrue = this.data[0].beDefault;
        } else {
          this.SelectTrue = "0";
        }
        if (arr.length > 1) {
          this.showList = arr.slice(1);
          this.showList.forEach((item, Index) => {
            this.showDefault[Index] = item[0].beDefault;
          });
        }
        console.log(this.data, this.showList);
      });

      this.loading = true;
      console.log(this.lang);
      axios
        .post("/AchievementMaster/selectAchievementsMaster", {})
        .then(res => {
          this.loading = false;
          if (res) {
            this.dataListName = res;
            let this_ = this;
            for (var i in this_.dataListName) {
              var Title = "";
              this.lang == "en"
                ? (Title = this_.dataListName[i].enName)
                : (Title = this_.dataListName[i].name);
              var Key = this_.dataListName[i].code;

              this.columns.splice(this.columns.length - 1, 0, {
                title: Title,
                key: Key,
                align: "center",
                minWidth: 120,
                render: (h, params) => {
                  return h(
                    "Checkbox",
                    {
                      props: {
                        size: "small",
                        value: params.row[params.column.key]
                      },
                      on: {
                        "on-change": e => {
                          this_.data[params.index][params.column.key] = e;
                          params.row[params.column.key] = e;
                          this_.checkedData = [];
                          if (params.row.achievementsDetailList.length > 0) {
                            this_.dataListName.forEach((item2, index) => {
                              params.row.achievementsDetailList.forEach(
                                item => {
                                  if (item2.code == item.achItemMasterId) {
                                    this_.checkedData.push(
                                      item.achItemMasterId
                                    );
                                  }
                                }
                              );
                            });
                          }
                          if (e == true) {
                            this_.checkedData.push(params.column.key);
                            this_.checkedData = [...new Set(this_.checkedData)];
                            this_.data[
                              params.index
                            ].achievementsDetailList.push({
                              achItemMasterId: params.column.key
                            });
                            params.row.achievementsDetailList.push({
                              achItemMasterId: params.column.key
                            });
                          } else {
                            this_.checkedData.forEach((item, indexs) => {
                              if (item == params.column.key) {
                                this_.checkedData.splice(indexs, 1);
                              }
                            });
                            this_.data[
                              params.index
                            ].achievementsDetailList.forEach((item, indexs) => {
                              if (item.achItemMasterId == params.column.key) {
                                this_.data[
                                  params.index
                                ].achievementsDetailList.splice(indexs, 1);
                              }
                            });
                            params.row.achievementsDetailList =
                              this_.data[params.index].achievementsDetailList;
                          }
                        }
                      }
                    },
                    ""
                  );
                }
              });

              this.columns1.splice(this.columns1.length - 1, 0, {
                title: Title,
                key: Key,
                align: "center",
                minWidth: 120,
                render: (h, params) => {
                  return h(
                    "Checkbox",
                    {
                      props: {
                        size: "small",
                        value: params.row[params.column.key]
                      },
                      on: {
                        "on-change": e => {
                          this_.showList.forEach((item, Index) => {
                            item.forEach(item2 => {
                              if (item2.id == params.row.id) {
                                this.fondIndex = Index;
                              }
                            });
                          });
                          this_.showList[this.fondIndex][params.index][
                            params.column.key
                          ] = e;
                          params.row[params.column.key] = e;
                          this_.checkedData = [];
                          if (params.row.achievementsDetailList.length > 0) {
                            this_.dataListName.forEach((item2, index) => {
                              params.row.achievementsDetailList.forEach(
                                item => {
                                  if (item2.code == item.achItemMasterId) {
                                    this_.checkedData.push(
                                      item.achItemMasterId
                                    );
                                  }
                                }
                              );
                            });
                          }
                          if (e == true) {
                            this_.checkedData.push(params.column.key);
                            this_.checkedData = [...new Set(this_.checkedData)];
                            params.row.achievementsDetailList.push({
                              achItemMasterId: params.column.key
                            });
                            this_.showList[this.fondIndex][
                              params.index
                            ].achievementsDetailList.push({
                              achItemMasterId: params.column.key
                            });
                          } else {
                            this_.checkedData.forEach((item, indexs) => {
                              if (item == params.column.key) {
                                this_.checkedData.splice(indexs, 1);
                              }
                            });
                            params.row.achievementsDetailList.forEach(
                              (item, indexs) => {
                                if (item.achItemMasterId == params.column.key) {
                                  params.row.achievementsDetailList.splice(
                                    indexs,
                                    1
                                  );
                                }
                              }
                            );
                            this_.showList[this.fondIndex][
                              params.index
                            ].achievementsDetailList =
                              params.row.achievementsDetailList;
                          }
                        }
                      }
                    },
                    ""
                  );
                }
              });
            }
          }
        });
    },
    addBtn() {
      this.showList.push([]);
      this.showDefault.push("0");
    },
    getDefault() {
      if (this.SelectTrue == "1") {
        this.data.forEach(item => {
          item.beDefault = "1";
        });
      } else {
        this.data.forEach(item => {
          item.beDefault = "0";
        });
      }
    },
    changeDefault(Index) {
      if (this.showDefault[Index] == "1") {
        this.showList[Index].forEach(item => {
          item.beDefault = "1";
        });
      } else {
        this.showList[Index].forEach(item => {
          item.beDefault = "0";
        });
      }
    },
    editData(row, index) {
      this.action = 2;
      this.actionIndex = index;
      this.assessmentType = true;
      this.formItem = { ...row };

      this.checkedData = [];
      if (row.achievementsDetailList.length > 0) {
        this.dataListName.forEach((item2, index) => {
          this.formItem[item2.code] = false;
          row.achievementsDetailList.forEach(item => {
            if (item2.code == item.achItemMasterId) {
              this.checkedData.push(item.achItemMasterId);
            }
          });
        });
      }
    },
    deletedData(index) {
      this.data.splice(index, 1);
    },
    addAssessmentType() {
      this.action = 1;
      this.assessmentType = true;
      this.formItem = {};
      this.checkedData = [];
    },
    confirmSave() {
      this.evaTypeRepeat1 = false;
      this.evaTypeRepeat2 = false;
      this.evaTypeRepeat3 = false;
      this.data.forEach((item, index) => {
        if (item.evaType == "3" && this.formItem.evaType == "3") {
          this.evaTypeRepeat3 = true;
          if (this.action == "2" && this.actionIndex == index) {
            this.evaTypeRepeat3 = false;
          }
        } else if (item.evaType == "2" && this.formItem.evaType == "2") {
          this.evaTypeRepeat2 = true;
          if (this.action == "2" && this.actionIndex == index) {
            this.evaTypeRepeat2 = false;
          }
        } else if (item.evaType == "1" && this.formItem.evaType == "1") {
          this.evaTypeRepeat1 = true;
          if (this.action == "2" && this.actionIndex == index) {
            this.evaTypeRepeat1 = false;
          }
        }
      });
      if (this.evaTypeRepeat1 == true) {
        this.$Message.error(this.$t("考评类型不能有多条年初！")); //考评类型不能有多条年初！
        return;
      }
      if (this.evaTypeRepeat2 == true) {
        this.$Message.error(this.$t("考评类型不能有多条年中！")); //考评类型不能有多条年中！
        return;
      }
      if (this.evaTypeRepeat3 == true) {
        this.$Message.error(this.$t("考评类型不能有多条年底！")); //考评类型不能有多条年底！
        return;
      }
      if (this.action == "1") {
        this.formItem.beDefault = this.SelectTrue;
        this.formItem.tableId = "1";
        this.formItem.achievementsDetailList = [];
        for (var i = 0; i < this.checkedData.length; i++) {
          this.formItem[this.checkedData[i]] = true;
          this.formItem.achievementsDetailList.push({
            achItemMasterId: this.checkedData[i]
          });
          this.formItem.achEndYear = [];
        }
        if (this.data[0]) {
          this.formItem.roleId = this.data[0].roleId
            ? this.data[0].roleId
            : null;
        }
        this.data.push(this.formItem);
      } else if (this.action == "2") {
        for (var i = 0; i < this.checkedData.length; i++) {
          this.formItem[this.checkedData[i]] = true;
        }
        this.data.splice(this.actionIndex, 1, this.formItem);
        this.data[this.actionIndex].achievementsDetailList = [];
        for (var i = 0; i < this.checkedData.length; i++) {
          this.data[this.actionIndex].achievementsDetailList.push({
            achItemMasterId: this.checkedData[i]
          });
        }
      }
      console.log(this.data);
      this.assessmentType = false;
    },
    openSelectRole() {
      this.selectRole = true;
      this.roleId = [];
      if (this.data.length >= 0 && this.data[0].hasOwnProperty("roleId")) {
        this.roleId = this.data[0].roleId ? this.data[0].roleId.split(",") : "";
      }
      axios.post("/AchievementType/selectRole", {}).then(res => {
        this.roleList = res;
      });
    },
    confirmSelect() {
      this.selectRole = false;
      this.roleId.length > 0
        ? this.roleId.forEach(item => {
            this.str = this.str + "," + item;
          })
        : "";
      this.str = this.str.substr(1);
      this.data.forEach(item => {
        item.roleId = this.str;
      });
      this.str = "";
    },

    addAssessmentTypes(Index) {
      this.assessmentTypes = true;
      this.formItem = {};
      this.fewTables = Index;
      this.action = 1;
      this.checkedData = [];
    },
    editBtn(row, index, Index) {
      this.action = 2;
      this.assessmentTypes = true;
      this.theIndex = index;
      this.fewTables = Index;
      this.formItem = { ...row };
      this.checkedData = [];
      if (row.achievementsDetailList.length > 0) {
        this.dataListName.forEach((item2, index) => {
          this.formItem[item2.code] = false;
          row.achievementsDetailList.forEach(item => {
            if (item2.code == item.achItemMasterId) {
              this.checkedData.push(item.achItemMasterId);
            }
          });
        });
      }
    },
    deletedBtn(index, Index) {
      this.tableId = this.showList[Index][index].tableId
        ? this.showList[Index][index].tableId
        : "";
      this.showList[Index].splice(index, 1);
    },
    confirmSaves() {
      this.evaTypeRepeat = false;
      this.showList[this.fewTables].forEach((item, index) => {
        if (item.evaType == "3" && this.formItem.evaType == "3") {
          this.evaTypeRepeat = true;
          if (this.action == "2" && this.theIndex == index) {
            this.evaTypeRepeat = false;
          }
        }
      });
      if (this.evaTypeRepeat == true) {
        this.$Message.error(this.$t("考评类型不能有多条年底！")); //考评类型不能有多条年底！
        return;
      }
      if (this.action == "1") {
        this.formItem.beDefault = this.showDefault[this.fewTables];
        // this.formItem.tableId = this.fewTables + 2;
        this.formItem.achievementsDetailList = [];
        if (this.showList[this.fewTables][0]) {
          this.formItem.roleId = this.showList[this.fewTables][0].roleId
            ? this.showList[this.fewTables][0].roleId
            : null;
        }
        for (var i = 0; i < this.checkedData.length; i++) {
          this.formItem[this.checkedData[i]] = true;
          this.formItem.achievementsDetailList.push({
            achItemMasterId: this.checkedData[i]
          });
          this.formItem.achEndYear = [];
        }
        this.showList[this.fewTables].push(this.formItem);
      } else if (this.action == "2") {
        for (var i = 0; i < this.checkedData.length; i++) {
          this.formItem[this.checkedData[i]] = true;
        }
        this.showList[this.fewTables].splice(this.theIndex, 1, this.formItem);
        this.showList[this.fewTables][
          this.theIndex
        ].achievementsDetailList = [];
        for (var i = 0; i < this.checkedData.length; i++) {
          this.showList[this.fewTables][
            this.theIndex
          ].achievementsDetailList.push({
            achItemMasterId: this.checkedData[i]
          });
        }
      }
      this.assessmentTypes = false;
    },
    selectListId(Index) {
      this.listId = true;
      this.selectId = [];
      this.Index = Index;
      if (this.showList[this.Index].length > 0) {
        if (this.showList[this.Index][0].hasOwnProperty("roleId")) {
          this.selectId = this.showList[this.Index][0].roleId
            ? this.showList[this.Index][0].roleId.split(",")
            : "";
        }
      }
      axios.post("/AchievementType/selectRole", {}).then(res => {
        this.roleList = res;
      });
    },
    selectConfirm() {
      this.listId = false;
      this.selectId.forEach(item => {
        this.str = this.str + "," + item;
      });
      this.str = this.str.substr(1);
      this.showList[this.Index].forEach(item => {
        item.roleId = this.str;
      });
      this.str = "";
    },

    deleted(Index) {
      this.$Modal.confirm({
        title: this.$notice("deletion"),
        content: "",
        onOk: () => {
          this.showList.splice(Index, 1);
          this.showDefault.splice(Index, 1);
        }
      });
    },

    saveData() {
      this.countNum = this.SelectTrue == "1" ? 1 : 0;
      this.showDefault.forEach((item, index) => {
        if (item == "1") {
          this.countNum += 1;
        }
      });
      if (this.countNum > 1) {
        this.$Message.error(this.$t("绩效类型不能多条默认为“是”！")); //绩效类型不能多条默认为“是”！
        return;
      }
      if (this.countNum < 1) {
        this.$Message.error(this.$t("绩效类型必须有一条默认为“是”！")); //绩效类型必须有一条默认为“是”！
        return;
      }
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          this.loading = true;
          // let arr = JSON.parse(JSON.stringify(this.data)),
          // for (var i = 0; i < this.showList.length; i++) {
          //   for (var j = 0; j < this.showList[i].length; j++) {
          //     arrList = arrList.concat(JSON.parse(JSON.stringify(this.showList[i][j])));
          //   }
          // }
          this.data.forEach(item => {
            item.createUserId = JSON.parse(
              sessionStorage.getItem("userInfo")
            ).userId;
            item.updateUserId = JSON.parse(
              sessionStorage.getItem("userInfo")
            ).userId;
          });
          this.showList.forEach(item => {
            item.forEach(item2 => {
              item2.createUserId = JSON.parse(
                sessionStorage.getItem("userInfo")
              ).userId;
              item2.updateUserId = JSON.parse(
                sessionStorage.getItem("userInfo")
              ).userId;
            });
          });
          let ary = [this.data, ...this.showList];
          axios.post("/AchievementType/saveAchievementType", ary).then(res => {
            this.loading = false;
            if (res.errorMessage == null) {
              this.data = [];
              this.showList = [];
              this.showDefault = [];
              this.columns = this.columns
                .slice(0, 2)
                .concat(this.columns.slice(-1));
              this.columns1 = this.columns1
                .slice(0, 2)
                .concat(this.columns1.slice(-1));
              this.getData();
              this.$Message.success(this.$t("Save_Successful")); //保存成功！
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.checkStyle {
  display: inline-block;
  width: 150px;
  margin: 10px 0;
}
.ivu-checkbox-group-item {
  display: block;
  margin: 15px 0 !important;
}
>>> .ivu-modal-body {
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PerformanceType.vue